import { RootState } from "../store";

export const selectBeneficiaryTypes = (state: RootState) => state.beneficiaryTypes.beneficiaryTypes;
export const selectErrorMessageBeneficiaryTypes = (state: RootState) => state.beneficiaryTypes.errorMessage;
